import { AxiosRequestConfig } from 'axios';

import {
  CurrentStatusAssignment,
  CurrentStatusExam,
  ProblemAndAnswer,
} from '../shared';
import { BASE_API } from '../utils';

export interface CurrentStatusIndexItem {
  exercise?: CurrentStatusAssignment | CurrentStatusExam;
  help?: number;
  helpRequestedProblem?: ProblemAndAnswer & {
    overrideId?: number;
  };
  firstName: string;
  isInIndividualMixedReview: boolean;
  lastCorrect?: string;
  lastName: string;
  online: boolean;
  score?: number;
  studentInClassId: string;
  studentName: string;
  totalToday: number;
  type?: 'HandLowered' | 'HandRaised';
  statusReceivedTimestamp?: string;
}

// TODO: Define types that are used in WS
// TODO: Clean up CurrentStatus calls
// TODO: Use this response
export type CurrentStatusIndexResponse = CurrentStatusIndexItem[];

interface ListConfig extends AxiosRequestConfig {
  baseURL: string;
  method: 'GET';
  url: `/teachers/${string}/classes/${string}/current-status`;
}

/**
 * GET /vo/v1/teachers/${teacherId}/classes/${classId}/current-status
 */
export const list = (teacherId: string, classId: string): ListConfig => {
  return {
    baseURL: BASE_API,
    method: 'GET',
    url: `/teachers/${teacherId}/classes/${classId}/current-status`,
  } as const;
};
